import { metrics } from '@atlassian/browser-metrics';

const SEARCH_DIALOG_METRIC_KEY = 'search-dialog';

export const SEARCH_DIALOG_DOWNLOAD_START_MARK = 'download-start';
export const SEARCH_DIALOG_DOWNLOAD_END_MARK = 'download-end';

export const searchDialogMetric = metrics.pageSegmentLoad({
	key: SEARCH_DIALOG_METRIC_KEY,
	timings: [
		{
			key: 'download',
			startMark: SEARCH_DIALOG_DOWNLOAD_START_MARK,
			endMark: SEARCH_DIALOG_DOWNLOAD_END_MARK,
		},
	],
});
